import { IconButton, TableCell, TableRow, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { DefaultLittleMessage } from '@root-gipro/constants/constants'
import {
  TAdminObjectAnalog,
} from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'
import { setAdminDeleteModalOA } from '@root-gipro/modules/AdminPanel/store/actions/actionAdminObjectsAnalog'

const AdminObjectsAnalogTableRow: FC<{
  objectAnalog: TAdminObjectAnalog
}> = ({
  objectAnalog
}) =>   {

  const dispatch = useDispatch();

  const onDeleteOAHandler = (idObjectAnalog: number) => {
    dispatch(setAdminDeleteModalOA({
      isOpen: true,
      idObjectAnalog,
    }));
  };

  return (
    <TableRow className='adminPanel__tableRow'>
      <TableCell
        className='adminPanelCell__solution'
        align='center'
        style={{ width: '10%' }}
      >
        <IconButton
          size='small'
          aria-label='Удалить'
          data-popup='delete_solution'
          onClick={() => onDeleteOAHandler(objectAnalog.id)}
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </TableCell>

      <TableCell
        className='adminPanelCell__solution'
        align='center'
        style={{ width: '15%' }}
      >
        {objectAnalog.id}
      </TableCell>

      <Tooltip title={objectAnalog.name}>
        <TableCell
          className='adminPanelCell__solution'
          style={{ width: '40%' }}
        >
          <div className='adminPanelCell__solution_name'>
            {objectAnalog.name}
          </div>
        </TableCell>
      </Tooltip>

      <Tooltip title={objectAnalog?.th_name || DefaultLittleMessage}>
        <TableCell
          align='center'
          style={{ width: '20%' }}
        >
          {objectAnalog?.th_name || DefaultLittleMessage}
        </TableCell>
      </Tooltip>

      <TableCell
        align='center'
        style={{ width: '20%' }}
      >
        {objectAnalog?.th_count || DefaultLittleMessage}
      </TableCell>

      <TableCell
        align='center'
        style={{ width: '20%' }}
      >
        {objectAnalog?.th_unit || DefaultLittleMessage}
      </TableCell>

      <TableCell
        align='center'
        style={{ width: '20%' }}
      >
        {objectAnalog.total === 0
          ? objectAnalog.total
          : (objectAnalog.total ? Intl.NumberFormat('ru-RU').format(objectAnalog.total / 1000) : DefaultLittleMessage)}
      </TableCell>
    </TableRow>
  )
};

export default AdminObjectsAnalogTableRow
